const DB_NAME = 'filoteca';
const DB_VERSION = 1;
const STORES = ['catalog', 'epg', 'details', 'progress', 'favorites', 'meta'];

let dbPromise = null;

function open() {
    if (dbPromise) return dbPromise;
    dbPromise = new Promise((resolve, reject) => {
        if (!window.indexedDB) {
            reject(new Error('IndexedDB no disponible'));
            return;
        }
        const req = indexedDB.open(DB_NAME, DB_VERSION);
        req.onupgradeneeded = (event) => {
            const db = event.target.result;
            STORES.forEach((name) => {
                if (!db.objectStoreNames.contains(name)) {
                    db.createObjectStore(name, { keyPath: 'key' });
                }
            });
        };
        req.onsuccess = () => {
            const db = req.result;
            db.onversionchange = () => db.close();
            resolve(db);
        };
        req.onerror = () => reject(req.error);
        req.onblocked = () => reject(new Error('IndexedDB bloqueada'));
    });
    return dbPromise;
}

function tx(storeName, mode, fn) {
    return open().then((db) => new Promise((resolve, reject) => {
        const transaction = db.transaction(storeName, mode);
        const store = transaction.objectStore(storeName);
        let result;
        try {
            result = fn(store);
        } catch (err) {
            reject(err);
            return;
        }
        transaction.oncomplete = () => resolve(result && result.result !== undefined ? result.result : result);
        transaction.onerror = () => reject(transaction.error);
        transaction.onabort = () => reject(transaction.error);
    }));
}

/* Respaldo en memoria cuando IndexedDB no está disponible (modo privado en algunos WebViews). */
const memory = {};

function mem(store) {
    return (memory[store] = memory[store] || new Map());
}

export const db = {
    async get(store, key) {
        try {
            const row = await tx(store, 'readonly', (s) => s.get(key));
            return row ? row.value : undefined;
        } catch (e) {
            return mem(store).get(key);
        }
    },

    async put(store, key, value) {
        try {
            await tx(store, 'readwrite', (s) => s.put({ key, value, updated: Date.now() }));
        } catch (e) {
            mem(store).set(key, value);
        }
    },

    async delete(store, key) {
        try {
            await tx(store, 'readwrite', (s) => s.delete(key));
        } catch (e) {
            mem(store).delete(key);
        }
    },

    async getAll(store) {
        try {
            const rows = await tx(store, 'readonly', (s) => s.getAll());
            return (rows || []).map((r) => ({ key: r.key, value: r.value, updated: r.updated }));
        } catch (e) {
            return Array.from(mem(store).entries()).map(([key, value]) => ({ key, value }));
        }
    },

    async clear(store) {
        try {
            await tx(store, 'readwrite', (s) => s.clear());
        } catch (e) {
            mem(store).clear();
        }
    },

    async deleteByPrefix(store, prefix) {
        const rows = await this.getAll(store);
        await Promise.all(rows.filter((r) => String(r.key).indexOf(prefix) === 0).map((r) => this.delete(store, r.key)));
    },

    async estimate() {
        if (navigator.storage && navigator.storage.estimate) {
            try {
                const est = await navigator.storage.estimate();
                return est.usage || 0;
            } catch (e) { /* ignore */ }
        }
        return 0;
    }
};
